var Modal = require("components/utility/AltModal");
var ErrorDisplay = require("components/utility/ErrorDisplay");

require("writing/responses/name_modal.scss");

class NameModal extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	onSubmit() {
		this.refs.errors.reset();

		var name = this.refs.signatureField.value.trim();
		if (name.length > 4) {
			this.props.onNameEntry(name);
		} else {
			this.refs.errors.setError("Please enter your full name.");
		}
	}

	show() {
		this.refs.modal.show();
	}

	hide() {
		this.refs.modal.hide();
	}
 
	render() {
		return (
			<Modal modalOrder={ 3 } className="nameModal" ref="modal" headerText="Now, sign your work!">
				<ErrorDisplay ref="errors" />
				<div className="clearfix nameLine">
					<a href="#" onClick={ this.onSubmit } className="btn buttonPrimary pull-right">
						I'm Done!
					</a>

					<div className="signatureWrap">
						<input className="form-control" ref="signatureField"
							placeholder="Your first and last name" />
					</div>
				</div>	
			</Modal>
		);
	}
};

NameModal.propTypes = StrictPropTypes({
	onNameEntry: PropTypes.func.isRequired
});

module.exports = NameModal;



// WEBPACK FOOTER //
// ./modules/components/writing/responses/NameModal.js